import styles from './LPHeader.module.scss';
import CTAButton, { BUTTON_STYLE } from 'component/atoms/Buttons/CTAButton';
import { TEXT_COLOR } from 'component/atoms/typographie/Text';
import { MODAL_IDENTIFIER } from 'core/enum/modals.enum';
import { useContext } from 'react';
import ModalContext from 'core/context/modal.context';
import LPBurgerMenu from '../LPBurgerMenu';
import LPNavigation from '../LPNavigation';
import { Link, useLocation } from 'react-router-dom';

const LPHeader = () => {
  const location = useLocation();
  const { openModal } = useContext(ModalContext);

  const renderLogo = () => <div className={`${styles.logo} app-logo`} />;

  return (
    <header className={styles.wrapper}>
      <div className={styles.left}>
        {location.pathname === '/' ? (
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>{renderLogo()}</button>
        ) : (
          <Link to={'/'}>{renderLogo()}</Link>
        )}

        <div className={styles.hideMobile}>
          <LPNavigation />
        </div>
      </div>

      <div className={styles.mobileWrapper}>
        <div className={styles.buttonWrapper}>
          <CTAButton
            onClick={() => openModal({ id: MODAL_IDENTIFIER.SIGN_UP_USER })}
            rounded={false}
            color={TEXT_COLOR.TEXT_COLOR_DARK}
            buttonStyle={BUTTON_STYLE.PRIMARY}
            buttonText={'Objekt inserieren'}
          />
          <CTAButton
            customStyling={styles.hideMobile}
            onClick={() => openModal({ id: MODAL_IDENTIFIER.SIGN_IN })}
            rounded={false}
            color={TEXT_COLOR.TEXT_COLOR_DARK}
            buttonStyle={BUTTON_STYLE.TERTIARY}
            buttonText={'Login'}
          />
          <CTAButton
            customStyling={styles.hideMobile}
            onClick={() => openModal({ id: MODAL_IDENTIFIER.SIGN_UP_USER })}
            rounded={false}
            color={TEXT_COLOR.TEXT_COLOR_DARK}
            buttonStyle={BUTTON_STYLE.TERTIARY}
            buttonText={'Konto erstellen'}
          />
        </div>
        <LPBurgerMenu />
      </div>
    </header>
  );
};

export default LPHeader;
